import { render, staticRenderFns } from "./ShoppinCartGifts.vue?vue&type=template&id=e5aee3ec&scoped=true"
import script from "./ShoppinCartGifts.vue?vue&type=script&lang=js"
export * from "./ShoppinCartGifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aee3ec",
  null
  
)

export default component.exports